/** Champ de recherche avec icône et debounce */

import { useEffect, useState } from 'react';
import { Search } from 'lucide-react';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  debounceMs?: number;
}

export function SearchInput({
  value,
  onChange,
  placeholder = 'Rechercher...',
  debounceMs = 300,
}: SearchInputProps) {
  const [local, setLocal] = useState(value);

  // Synchroniser la valeur externe
  useEffect(() => setLocal(value), [value]);

  // Debounce
  useEffect(() => {
    const timer = setTimeout(() => {
      if (local !== value) onChange(local);
    }, debounceMs);
    return () => clearTimeout(timer);
  }, [local, debounceMs, onChange, value]);

  return (
    <div className="relative">
      <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400" size={14} />
      <input
        type="text"
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        placeholder={placeholder}
        className="w-full pl-8 pr-3 py-1.5 text-sm border border-gray-300 rounded-md
                   placeholder:text-gray-400
                   focus:outline-none focus:ring-1 focus:ring-accent focus:border-accent"
      />
    </div>
  );
}
